import React from 'react'
import ReactDOM from 'react-dom'

import Contracts from './components/Contracts' // @TODO: components as paths
import './index.css'

ReactDOM.render(<Contracts />, document.getElementById('root'))
